"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _Box = require("../Box");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var computeUnderline = function computeUnderline(state, behavior) {
  var blocklist = state === "hover" ? ["none"] : ["hover", "none"];
  var none = blocklist.includes(behavior);
  return none ? "none" : "underline";
};

var backwardsCompatCompute = function backwardsCompatCompute(state, props) {
  var behavior = props.noUnderline ? "hover" : props.underlineBehavior;
  return computeUnderline(state, behavior);
};
/**
 * Basic <a> tag styled with additional LinkProps
 *
 * @deprecated If working in Force, please use `RouterLink`.
 */


var Link = _styledComponents.default.a.withConfig({
  displayName: "Link",
  componentId: "oxrwcw-0"
})(["color:", ";transition:color 0.25s;text-decoration:", ";&:hover{text-decoration:", ";color:", ";}", ";"], (0, _helpers.color)("black100"), function (props) {
  return backwardsCompatCompute("normal", props);
}, function (props) {
  return backwardsCompatCompute("hover", props);
}, function (props) {
  return props.hoverColor ? (0, _helpers.color)(props.hoverColor) : (0, _helpers.color)("black100");
}, _Box.boxMixin);

exports.Link = Link;
Link.displayName = "Link";
Link.defaultProps = {
  underlineBehavior: "default"
};